import {useEffect, useRef} from 'react'
import styles from './bottom-sheet.module.scss'

/**
 * @param {{
 *   open: boolean,
 *   onClose: () => void,
 *   title?: string,
 *   children: React.ReactNode
 * }} props
 */
export function BottomSheet({open, onClose, title, children}) {
    const sheetRef = useRef(null)

    useEffect(() => {
        if (!open)
            return undefined
        const previousOverflow = document.body.style.overflow
        document.body.style.overflow = 'hidden'
        const handleKey = (e) => {
            if (e.key === 'Escape')
                onClose()
        }
        document.addEventListener('keydown', handleKey)

        const previouslyFocused = document.activeElement
        if (sheetRef.current) {
            const focusable = sheetRef.current.querySelector('button, [href], input, textarea, select, [tabindex]:not([tabindex="-1"])')
            if (focusable instanceof HTMLElement)
                focusable.focus()
        }

        return () => {
            document.body.style.overflow = previousOverflow
            document.removeEventListener('keydown', handleKey)
            if (previouslyFocused instanceof HTMLElement)
                previouslyFocused.focus()
        }
    }, [open, onClose])

    if (!open)
        return null

    return (
        <div className={styles.overlay} role="dialog" aria-modal="true" aria-label={title}>
            <button
                type="button"
                className={styles.scrim}
                onClick={onClose}
                aria-label="Close sheet"
            />
            <div className={styles.sheet} ref={sheetRef}>
                <div className={styles.dragger} aria-hidden="true"/>
                {title && <h2 className={styles.title}>{title}</h2>}
                <div className={styles.body}>{children}</div>
            </div>
        </div>
    )
}
